import { Navigate, useLocation, useRouterState } from '@tanstack/react-router';
import { useAuth } from '@vizit/auth';
import { BackToNavbar } from '@vizit/organisms';
import { useLegacyWorkspaceRedirect } from '../route-utils/legacy-redirect';

function NotFoundPage() {
  const { isAuthenticated } = useAuth();
  const { pathname, search } = useLocation();
  const legacyRedirect = useLegacyWorkspaceRedirect(pathname, search);
  // `isLoading` clears once a navigation's matches are committed. `status` only turns idle once every match has
  // stopped pending, which never happens below a beforeLoad that threw notFound(), so it cannot gate this page.
  const isRouterLoading = useRouterState({ select: (state) => state.isLoading });

  if (isRouterLoading) {
    return null;
  }

  if (isAuthenticated && legacyRedirect.status === 'resolving') {
    return null;
  }

  if (isAuthenticated && legacyRedirect.status === 'redirect') {
    return <Navigate to={legacyRedirect.to} search={legacyRedirect.search} replace />;
  }

  if (!isAuthenticated) {
    return (
      <div className="h-screen flex flex-col bg-white">
        <div className="flex flex-col items-center justify-center h-full">
          <h1 className="text-display-2xl font-bold">404</h1>
          <p className="text-body-lg">Page not found</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <BackToNavbar previousPageName="Home" to="/" />
      <div className="bg-white flex-grow w-full content-center">
        <div className="flex flex-col items-center justify-center h-full">
          <h1 className="text-display-2xl font-bold">404</h1>
          <p className="text-body-lg">Page not found</p>
        </div>
      </div>
    </div>
  );
}

export { NotFoundPage };
